import { create } from 'zustand';

export const usePontosOperacionaisStore = create((set) => ({

    pontosOperacionais: [],

    pontosOperacionaisMap: new Map(),

    loaded: false,

    setPontosOperacionais: (pontos = []) => {

        const normalized = [...pontos];

        set({
            pontosOperacionais: normalized,

            pontosOperacionaisMap: new Map(
                normalized.map(ponto => [
                    String(ponto.ID),
                    ponto
                ])
            ),

            loaded: true
        });
    },

    upsertPontoOperacional: (ponto) => {

        if (!ponto?.ID) {
            return;
        }

        set(state => {

            const id = String(ponto.ID);

            const map = new Map(
                state.pontosOperacionaisMap
            );

            map.set(
                id,
                ponto
            );

            return {
                pontosOperacionaisMap: map,
                pontosOperacionais: Array.from(
                    map.values()
                )
            };
        });
    },

    removePontoOperacional: (pontoId) => {

        if (!pontoId) {
            return;
        }

        set(state => {

            const id = String(pontoId);

            const map = new Map(
                state.pontosOperacionaisMap
            );

            map.delete(id);

            return {
                pontosOperacionaisMap: map,
                pontosOperacionais: Array.from(
                    map.values()
                )
            };
        });
    },

    resetPontosOperacionais: () => {

        set({
            pontosOperacionais: [],
            pontosOperacionaisMap: new Map()
        });
    }

}));